import React from 'react';

function DeleteAccount() {
  return (
    <div className="container-xxl py-4 text-start">
      {/* Page Header */}
      <div className="info-banner dark shadow-sm mb-5">
        <h1 className="fw-bold mb-3">Account Deletion</h1>
        <p className="lead opacity-75 mb-0">We're sorry to see you go. If you've decided to close your account, follow these simple steps.</p>
      </div>

      <div className="row justify-content-center">
        <div className="col-lg-8">
          <div className="bg-white p-4 p-md-5 rounded-4 border shadow-sm info-section">
            <h2 className="fw-bold mb-4 h4">How to Delete Your Account</h2>

            <div className="mb-4 d-flex align-items-start gap-3">
              <div className="bg-primary text-white rounded-circle flex-shrink-0 d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px' }}>1</div>
              <div>
                <h5 className="fw-bold mb-1">Log in to the App</h5>
                <p className="text-muted small">Open the ToyTrade app on your device and sign in to the account you wish to delete.</p>
              </div>
            </div>

            <div className="mb-4 d-flex align-items-start gap-3">
              <div className="bg-primary text-white rounded-circle flex-shrink-0 d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px' }}>2</div>
              <div>
                <h5 className="fw-bold mb-1">Go to Account Settings</h5>
                <p className="text-muted small">Navigate to the 'Account' tab (usually the last icon in the bottom menu) and look for your profile settings.</p>
              </div>
            </div>

            <div className="mb-4 d-flex align-items-start gap-3">
              <div className="bg-primary text-white rounded-circle flex-shrink-0 d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px' }}>3</div>
              <div>
                <h5 className="fw-bold mb-1">Select 'Delete Account'</h5>
                <p className="text-muted small">Tap on the "Delete Account" option. You will be asked to confirm this action.</p>
              </div>
            </div>

            <div className="mb-4 d-flex align-items-start gap-3">
              <div className="bg-primary text-white rounded-circle flex-shrink-0 d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px' }}>4</div>
              <div>
                <h5 className="fw-bold mb-1">Confirm Deletion</h5>
                <p className="text-muted small">Once confirmed, all your personal data, listings, and messages will be permanently removed from our servers.</p>
              </div>
            </div>

            <div className="p-4 bg-danger bg-opacity-10 border border-danger border-opacity-25 rounded-4 mt-5">
              <h5 className="text-danger fw-bold"><i className="bi bi-exclamation-triangle-fill me-2"></i> Important Notice</h5>
              <p className="mb-0 small text-dark opacity-75">
                Account deletion is permanent and cannot be undone. If you just want to take a break, you can simply sign out of the app instead. You can always sign back in later to find your listings intact.
              </p>
            </div>

            <div className="mt-5 text-center">
              <p className="text-muted small">Having trouble? Contact us at <a href="mailto:admin@topnear.com" className="text-decoration-none fw-bold">admin@topnear.com</a> and we'll help you out.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default DeleteAccount;
